import React from 'react';
import { FLOW_TYPES } from '@shared_modules/prescreen-components';

const getFooterConstants = (flowType = '') => {
  const footerText = {
    [FLOW_TYPES.DEFAULT]: (
      <p>
        Loans are made by LendingClub Bank, N.A., Member FDIC, Equal Housing Lender (“LendingClub Bank”), a wholly-owned
        subsidiary of LendingClub Corporation, NMLS ID 167439. Loans are subject to credit approval. Loan closing is
        contingent on accepting all required agreements and disclosures at Lendingclub.com. “LendingClub” is a trademark
        of LendingClub Bank.
      </p>
    ),
    [FLOW_TYPES.ILOC]: (
      <>
        <p>
          Unless otherwise specified, all credit and deposit products are provided by LendingClub Bank, N.A., Member
          FDIC, Equal Housing Lender (“LendingClub Bank”), a wholly-owned subsidiary of LendingClub Corporation, NMLS ID
          167439. Credit products are subject to credit approval and may be subject to sufficient investor commitment.
          Deposit accounts are subject to approval. Only deposit products are FDIC-insured.
        </p>
        <p>“LendingClub” and the “LC” symbol, and “CleanSweep” are trademarks of LendingClub Bank.</p>
      </>
    ),
    [FLOW_TYPES.TOPUP]: (
      <>
        <p>
          Unless otherwise specified, all credit and deposit products are provided by LendingClub Bank, N.A., Member
          FDIC, Equal Housing Lender (“LendingClub Bank”), a wholly-owned subsidiary of LendingClub Corporation, NMLS ID
          167439. Credit products are subject to credit approval and may be subject to sufficient investor commitment.
          Credit union membership may be required. Deposit accounts are subject to approval. Deposit products are
          FDIC-insured up to $250,000 per depositor, per ownership category.
        </p>
        <p>“LendingClub”, the “LC” symbol, and “TopUp” are trademarks of LendingClub Bank.</p>
      </>
    ),
  };

  const generalDisclaimer = footerText[flowType] || footerText[FLOW_TYPES.DEFAULT];

  return {
    state: 'San Francisco, California 94105, USA',
    address: '595 Market Street, Suite 200',
    links: {
      home: 'Home',
      about: 'About Us',
      terms: 'Terms of Use',
      privacy: 'Privacy Policy',
    },
    generalDisclaimer,
    copyright: `© ${new Date().getFullYear()} LendingClub Bank. All rights reserved.`,
    equal: 'Equal Housing Lender',
  };
};

export { FLOW_TYPES, getFooterConstants };

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/rc-footer/Footer.scss');